import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import {
  CompanyMarginsBulkSaveResponseDto,
  CompanyMarginsResponseDto,
} from './dtos/company-margins.dto';
import { CompanyMarginsMapper } from './mappers/company-margins.mapper';
import { CompanyMarginsPayloadMapper } from './mappers/company-margins.payload.mapper';
import {
  CompanyMargin,
  CompanyMarginSave,
} from '../state/company-margins/company-margins-state.model';

@Injectable({ providedIn: 'root' })
export class CompanyMarginsApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);
  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _mapper = new CompanyMarginsMapper();
  private readonly _payloadMapper = new CompanyMarginsPayloadMapper();

  public getCompanyMargins(companyId: number): Observable<CompanyMargin[]> {
    const params = new HttpParams().set('company_id', companyId);
    return this._http
      .get<CompanyMarginsResponseDto>(
        `${this._baseUrl}/pricing/margin/company_margins`,
        { params },
      )
      .pipe(map((res) => this._mapper.fromDtoList(res.data)));
  }

  public bulkSave(margins: CompanyMarginSave[]): Observable<CompanyMargin[]> {
    const payload = margins.map((margin) =>
      this._payloadMapper.toPayload(margin),
    );
    return this._http
      .post<CompanyMarginsBulkSaveResponseDto>(
        `${this._baseUrl}/pricing/margin/bulk_save`,
        payload,
      )
      .pipe(map((res) => this._mapper.fromDtoList(res.data ?? [])));
  }
}
